'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var AllowedCustomOpts = {
  MEETING_SIDEBAR: 'MEETING_SIDEBAR',
  SALES_EXTENSION_SIDEBAR: 'SALES_EXTENSION_SIDEBAR',
  LIVECHAT_SIDEBAR: 'LIVECHAT_SIDEBAR',
  LEADFLOWS_SIDEBAR: 'LEADFLOWS_SIDEBAR',
  FORMS_SIDEBAR: 'FORMS_SIDEBAR',
  DOCUMENTS_SIDEBAR: 'DOCUMENTS_SIDEBAR'
};

exports.default = AllowedCustomOpts;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/signup-ui-core/static-1.35/js/constants/AllowedCustomOpts.js
// module id = 304
// module chunks = 2 3